import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  SIGN_IN: 'SIGN_IN',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESTORE_PASSWORD: 'RESTORE_PASSWORD',
};

export const {
  signInRequest,
  signInSuccess,
  signInFailure,
} = generateApiActions(types.SIGN_IN);

export const {
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
} = generateApiActions(types.FORGOT_PASSWORD);

export const {
  restorePasswordRequest,
  restorePasswordSuccess,
  restorePasswordFailure,
} = generateApiActions(types.RESTORE_PASSWORD);

export const logout = createAction('LOGOUT');



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js